.dialog {
  --mtdsc-dialog-max-width: calc(var(--mtds-30) * 12);
  --mtdsc-dialog-max-height: 90dvh;
  width: calc(100vw - var(--mtds-8));
  block-size: min(90dvh, calc(var(--mtds-30) * 8));
  overflow: hidden;
}

.dialogBody {
  flex: 1;
  min-block-size: 0;
  grid-template-rows: auto minmax(0, 1fr);
}

.stepViewport {
  min-block-size: 0;
  overflow: hidden;
}

.stepPanel {
  min-block-size: 0;
  overflow: auto;
  overscroll-behavior: contain;
}

.catalogueStep {
  grid-template-rows: auto minmax(0, 1fr);
}

.previewStep {
  grid-template-rows: auto auto auto minmax(var(--mtds-15), 1fr);
}

.dialog .loadingSkeleton {
  block-size: var(--mtds-4);
  background: var(--mtdsc-skeleton-background);
}

.dialog .loadingTitle {
  inline-size: 60%;
  block-size: var(--mtds-6);
}

.dialog .loadingButton {
  inline-size: var(--mtds-18);
  block-size: var(--mtds-10);
}

@media (prefers-reduced-motion: reduce) {
  .dialog .loadingSkeleton {
    animation: none;
  }
}

.resultText {
  min-width: 0;
  overflow-wrap: anywhere;
}

.legislationCard {
  min-inline-size: 0;
  overflow-wrap: anywhere;
}

.scroll {
  min-block-size: 0;
  overflow: auto;
  overscroll-behavior: contain;
  align-content: start;
  scrollbar-gutter: stable;
}
